import React, { useEffect, useMemo, useState, type ChangeEvent } from 'react'
import { useSelector } from 'react-redux'
import { Flex, Space, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { filterObjectProps, formatCapitalizedString } from '@choreograph/layout'

import { useGetResourceTypesQuery } from '../../../state/apis/generated/resourceTypesApi'
import { selectNamespace } from '../../../state/slices/appSlice'
import { DropdownFilter } from '../../shared/DropdownFilter'
import { ISelectOption } from '../../../constants/types/common'

export const UserTableFilters = ({ setSearchFilter, searchFilter }) => {
  const namespace = useSelector(selectNamespace)

  useEffect(() => {
    handleResourceTypeSelect([])
  }, [namespace])

  const { data: resourceTypes = [] } = useGetResourceTypesQuery({ namespaces: namespace })

  const [selectedResourceTypes, setSelectedResourceTypes] = useState<string[] | null>([])

  const resourceTypeOptions: ISelectOption[] = useMemo(() => (
    // todo: check type after BE updating
    (resourceTypes as string[]).map(t => {
      const type: string = t.split('/')[1]
      const label = formatCapitalizedString(type.split('_').join(' '))
      return { label, value: type }
    })
  ), [resourceTypes])

  const handleSearchInput = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchFilter(
      filterObjectProps(
        {
          ...searchFilter,
          firstName: e.target.value,
          lastName: e.target.value,
          email: e.target.value,
        }
      )
    )
  }

  const handleResourceTypeSelect = (selected: string[]) => {
    setSelectedResourceTypes(selected.length ? selected : null)
    setSearchFilter(
      filterObjectProps(
        {
          ...searchFilter,
          resourceTypes: selected.length ? selected.map(s => `${namespace}/${s}`) : null
        }
      )
    )
  }
  return (
    <>
      {/* search */}
      <Flex gap={12}>
        <Space.Compact className='input-search'>
          <Space.Addon>
            <SearchOutlined />
          </Space.Addon>
          <Input
            placeholder='Search by name or email'
            onChange={handleSearchInput}
            allowClear={true}
          />
        </Space.Compact>
        {/* resourceType dropdown */}
        <DropdownFilter
          value={selectedResourceTypes}
          options={resourceTypeOptions}
          selectAllAction={() => handleResourceTypeSelect(resourceTypeOptions.map(x => x.value))}
          clearAllAction={() => handleResourceTypeSelect([])}
          onChange={handleResourceTypeSelect}
          placeholder='Resource types'
          disabled={!namespace}
        />
      </Flex>
    </>
  )
}
